// @flow
import { Faq } from './Faq';

export default Faq;
export { Faq };
